





































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import SimpleHeader from '@/modules/shared/components/shared/SimpleHeader.vue'
import { Prop } from 'vue-property-decorator'
import { ContentCampaignResourceTypeInAdmin } from '@/modules/content-campaign/models/content-campaign-resource.model'
import AdminContentCampaignFinancialTable
  from '@/modules/content-campaign/components/admin/table/AdminContentCampaignFinancialTable.vue'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import AdminContentCampaignItemsTable
  from '@/modules/content-campaign/components/admin/table/AdminContentCampaignItemsTable.vue'
import AdminInvoiceForModelTable from '@/modules/invoice/components/admin/table/AdminInvoiceForModelTable.vue'
import AdminChangelogTable from '@/modules/changelog/components/admin/AdminChangelogTable.vue'
import AdminContentCampaignShowTabular
  from '@/modules/content-campaign/components/admin/AdminContentCampaignShowTabular.vue'
import AdminContentCampaignShowSideNavigation
  from '@/modules/content-campaign/components/admin/AdminContentCampaignShowSideNavigation.vue'
import AdminContentCampaignUpdateAttributes
  from '@/modules/content-campaign/components/admin/AdminContentCampaignUpdateAttributes.vue'
import ContentHeadingsTable from '@/modules/content/components/shared/ContentHeadingsTable.vue'
import ContentImagesTable from '@/modules/content/components/shared/ContentImagesTable.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'کمپین محتوا'
  },
  metaInfo: {
    title: 'کمپین محتوا'
  },
  components: {
    AdminContentCampaignShowTabular,
    SimpleHeader,
    AdminContentCampaignFinancialTable,
    AdminContentCampaignItemsTable,
    AdminInvoiceForModelTable,
    AdminChangelogTable,
    AdminContentCampaignShowSideNavigation,
    AdminContentCampaignUpdateAttributes,
    ContentHeadingsTable,
    ContentImagesTable,
    AdminUserInfoButton
  }
})
export default class AdminContentCampaignShowPage extends Vue {
  @Prop() campaign: ContentCampaignResourceTypeInAdmin

  get campaignData() {
    return this.campaign.data
  }
}
